import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {MasterService} from '../../../core/service/master.service';
import {LayoutService} from '../../../core/service/layout.service';
import {WasuuErrorStateMatcher} from '../../../core/error-state/wasuu-error-state-matcher';


export interface SetLayoutDialogData {
  meisai: Partial<MeisaiData>,
  shubetsu: 'gridTile' | 'bikou',
}

interface MeisaiData {
  bikou: string
  text: string,
  cellWasuu: number | null,
}

@Component({
  selector: 'app-set-layout-dialog',
  templateUrl: './set-layout-dialog.component.html',
  styleUrls: ['./set-layout-dialog.component.scss', '../../layout/layout.component.scss']
})
export class SetLayoutDialogComponent implements OnInit {
  public meisai: MeisaiData = { bikou: '', text: '', cellWasuu: null };
  public shubetsu?: 'gridTile' | 'bikou';
  title = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: SetLayoutDialogData,
              public commonService: CommonService,
              public masterService: MasterService,
              public layoutService: LayoutService,
              public wasuuErrorStateMatcher: WasuuErrorStateMatcher,
              public matDialogRef: MatDialogRef<SetLayoutDialogComponent>,) { }

  /**
   *
   */
  ngOnInit(): void {
    this.meisai = Object.assign(this.meisai, this.data.meisai);
    this.shubetsu = this.data.shubetsu;
    if (this.data.shubetsu === 'gridTile') {
      this.title = 'テキスト';
    }
    if (this.data.shubetsu === 'bikou') {
      this.title = '備考';
    }
    console.log(this.meisai);
  }
}
